import {
    MissingTranslationHandler,
    MissingTranslationHandlerParams,
} from '@ngx-translate/core';

export class MissingTranslationDebugHandler
    implements MissingTranslationHandler
{
    handle(params: MissingTranslationHandlerParams) {
        return '#### MISSING ####';
    }
}
